import { Col, Form, Row, Typography } from "antd";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaInput } from "apps/Common/MazakaInput";
import useMazakaForm from "hooks/useMazakaForm";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { RootState } from "store/Reducers";
import { sendMessage } from "../Services";
import { FC } from "react";
import { MazakaButton } from "apps/Common/MazakaButton";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { MazakaTextArea } from "apps/Common/MazakaTextarea";

interface  SendMessageProps{
  onFinish?:any,
  externalAdvert?:any
}

const SendMessage:FC<SendMessageProps> = ({onFinish,externalAdvert}) => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const {userInfoes} = useSelector((state:RootState)=>state.profile)
  const { Text } = Typography;
    

   
  const handleOnFinish = async()=>{
     mazakaForm.setLoading()
    let formValues = form.getFieldsValue()

    
    let data = {
      AdvertId:Number(externalAdvert.id),
      sentUserId:externalAdvert?.userId,
      senderUserId:userInfoes.id,
      message:formValues["message"],
      messageFiles:[]

    }
    try {
        await sendMessage(data)
        mazakaForm.setSuccess(2000,()=>"Mesajınız başarıyla gönderildi")
        openNotificationWithIcon("default","Mesajınız başarıyla gönderildi")
        form.resetFields()
        onFinish()
    } catch (error:any) {
      mazakaForm.setFailed(2000,error?.message)
      console.log("Somethings wrong during sending message",error)
    }
  }


  return (
    <>
      <Col span={24}>
        <MazakaForm
        
          submitButtonVisible={false}
          form={form}
          onFinish={handleOnFinish}
          {...formActions}
        >
          <Row gutter={[0,20]}>
            
             
            <Col xs={24} className="!flex justify-center">
              <Text className="!text-black !font-bold !text-2xl">Mesaj Gönder</Text>
            </Col>
            
            <MazakaTextArea autoSize label='Mesaj' name={"message"}  placeholder="Mesajını Yaz" xs={24} rules={[{required:true,message:""}]} />
             <Col xs={24}>
                                  <MazakaButton
                                    className="!p-4 !bg-[#FFC502] !text-black"
                                    htmlType="submit"
                                   
                                    processType={formActions.submitProcessType}
                                  >
                                    Gönder
                                  </MazakaButton>
                                </Col>
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default SendMessage;
